module.exports = __webpack_public_path__ + "img/icon_jxspks.94d6d75b.png";